module.exports = __webpack_public_path__ + "img/flyerPlaceholder.8848ab61.png";